import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-paqueteria',
  templateUrl: './paqueteria.component.html',
  styleUrls: ['./paqueteria.component.css']
})
export class PaqueteriaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
